export default "__VITE_ASSET__DcvIwt2w__"